import React from 'react';

import {Layouts, Button} from '@components';
import {Props} from './types';
import * as hooks from './hooks';
import paths from '@paths';

import './index.scss';

const NotFound: React.FC<Props> = props => {
  const isAuthed = props.me.sub;

  hooks.useMount(isAuthed);

  return (
    <div className="a__notfound">
      {!isAuthed && (
        <Layouts.Header.Before
          history={props.history}
          location={props.location}
          match={props.match}
        />
      )}
      <div className="w__notfound-header">
        <div>
          <div className="b__title-header">ページが見つかりませんでした。</div>
          <div className="b__message-header">
            お探しのページはアドレスが間違っているか、
          </div>
          <div className="b__message-header">削除された可能性があります。</div>
          <div className="b__message-header">{`5秒後に${
            isAuthed ? 'ダッシュボード' : 'トップページ'
          }移動します。`}</div>
          <div className="b__action">
            <Button.Normal
              color="yellow"
              onClick={() => {
                if (isAuthed) {
                  window.location.href = paths.dashboard.main;
                } else {
                  window.location.href = paths.landing.main;
                }
              }}
              notFluid
            >
              {isAuthed ? 'ダッシュボード' : 'トップページ'}に移動する
            </Button.Normal>
          </div>
        </div>
      </div>
      <div className="w__footer">{!isAuthed && <Layouts.Footer.Main />}</div>
    </div>
  );
};

export default NotFound;
